import InputDateRange from "components/Form/InputDateRange/v1";
import { useContext, useEffect, useState } from "react";
import { ContextHistoryStock } from "../context/ContextProvider";
import moment from "moment";
import InputMultipleSelect from "components/Form/InputMultipleSelect";
import { getCustomers } from "apis/customers";
import { getSales } from "apis/sales";
import { getGudang } from "apis/gudang";

const Filter = () => {
  const { setQuery, query } = useContext(ContextHistoryStock);
  const [dateRange, setDateRange] = useState({
    startDate: moment().startOf("month").toDate(),
    endDate: moment().endOf("month").toDate(),
    key: "selection",
  });
  const { startDate, endDate } = dateRange;

  useEffect(() => {
    if (startDate && endDate) {
      setQuery((prevQuery) => ({
        ...prevQuery,
        watch: {
          ...prevQuery.watch,
          start_date: moment(startDate).format("YYYY-MM-DD"),
          end_date: moment(endDate).format("YYYY-MM-DD"),
        },
      }));
    }
  }, [startDate, endDate]);

  return (
    <div className="relative flex items-end gap-3">
      <div className="w-1/3">
        <InputMultipleSelect
          fetchList={getSales}
          keyLabel="sales_name"
          label="Pilih sales"
          keyValue="id_sales"
          onChange={(value) => {
            setQuery((prevQuery) => ({
              ...prevQuery,
              watch: { ...prevQuery.watch, id_sales: value },
            }));
          }}
          value={query.watch.id_sales}
          rounded
        />
      </div>
      <div className="w-1/3">
        <InputMultipleSelect
          fetchList={getCustomers}
          keyLabel="customer_name"
          label="Pilih pelanggan"
          keyValue="id_customer"
          onChange={(value) => {
            setQuery((prevQuery) => ({
              ...prevQuery,
              watch: { ...prevQuery.watch, id_customer: value },
            }));
          }}
          value={query.watch.id_customer}
          rounded
        />
      </div>
      <div className="w-1/3">
        <InputDateRange
          onChange={(update) => setDateRange(update)}
          value={dateRange}
        />
      </div>
      <div className="w-1/3">
        <InputMultipleSelect
          fetchList={getGudang}
          noLimit
          label="Pilih gudang"
          keyLabel="gudang_name"
          keyValue="id_gudang"
          onChange={(value) => {
            setQuery((prevQuery) => ({
              ...prevQuery,
              watch: { ...prevQuery.watch, id_region: value },
            }));
          }}
          value={query.watch.id_region}
          rounded
        />
      </div>
    </div>
  );
};

export default Filter;
